module.exports = __webpack_public_path__ + "img/BE0448490386.d9bf9386.png";